import {
  checkExpressionsResponseSchema,
  type ExpressionInput,
  type ExpressionCheckResult,
} from "@repo/shared";
import { API_V1_PREFIX, apiRequest } from "../api-client";

export type { ExpressionCheckResult };

export type ValidateExpressionsResult =
  | { valid: true; results: ExpressionCheckResult[] }
  | { valid: false; results: ExpressionCheckResult[] };

export async function validateExpressions(
  appId: string,
  connectionId: string,
  items: ExpressionInput[],
  pendingNames: string[],
): Promise<ValidateExpressionsResult> {
  const { payload, status } = await apiRequest({
    path: `${API_V1_PREFIX}/sync-apps/${encodeURIComponent(appId)}/validate-expressions`,
    method: "POST",
    body: { connectionId, items, pendingNames },
  }).catch((err: unknown) => {
    // On 400 with EXPRESSION_VALIDATION_FAILED, extract the results from details
    if (
      err &&
      typeof err === "object" &&
      "code" in err &&
      (err as { code: string }).code === "EXPRESSION_VALIDATION_FAILED" &&
      "details" in err
    ) {
      const details = (err as { details: unknown }).details;
      if (details && typeof details === "object" && "results" in details) {
        const parsed = checkExpressionsResponseSchema.safeParse(details);
        if (parsed.success) {
          return { payload: { data: parsed.data }, status: 400 };
        }
      }
    }
    throw err;
  });

  const data =
    payload &&
    typeof payload === "object" &&
    "data" in payload &&
    payload.data &&
    typeof payload.data === "object" &&
    "results" in payload.data
      ? payload.data
      : null;

  const parsed = checkExpressionsResponseSchema.safeParse(data);
  const results = parsed.success ? parsed.data.results : [];

  return {
    valid: status === 200,
    results,
  };
}
